<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add MX Merchant Payment Terminal</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSave()">

  <div class="modal-body">

    <div class="form-group">
      <label for="selectedTerminal">MX Merchant Terminal Name</label>
      <select class="custom-select" [(ngModel)]="selectedTerminal"
              id="selectedTerminal" name="selectedTerminal">
        <ng-container *ngIf="loadingPotentialTerminals">
          <option disabled class="disabled"
                  [ngValue]="null">
            Loading...
          </option>
        </ng-container>
        <ng-container *ngIf="!loadingPotentialTerminals">
          <option *ngIf="potentialTerminals.length > 0"
                  disabled class="disabled"
                  [ngValue]="null">
            Select a terminal
          </option>
          <option *ngFor="let pt of potentialTerminals"
                  [ngValue]="pt">
            {{ pt.name }}
          </option>
          <option *ngIf="potentialTerminals.length === 0"
                  disabled class="disabled"
                  [ngValue]="null">
            No unregistered terminals in connection
          </option>
        </ng-container>
      </select>
      <small class="form-text text-muted">
        Payment terminals must first be registered using the MX Merchant dashboard before they may be added in Capitan.
      </small>
    </div>

    <div *ngIf="!loadingPotentialTerminals && (potentialTerminals.length === 0)"
         class="alert alert-warning">
      This MX Merchant connection has no payment terminals which have not already been added in Capitan.
    </div>

    <div class="form-group">
      <label for="labelInput">Label</label>
      <input id="labelInput" type="text" class="form-control" name="label"
             required
             [(ngModel)]="label">
      <small class="form-text text-muted">
        This label will be used to refer to the terminal within Capitan. For locations with multiple payment terminals, this should correspond to a physical label on the terminal device.
      </small>

    </div>

    <div class="alert alert-info">This payment terminal will be registered for {{ location.name }}.</div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            [disabled]="!allInputsProvided()"
            [class.disabled] = '!allInputsProvided()'
            *ngIf="!loadingSubmit">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

  </form>

</ng-container>
